import { AddIcon, AddIconContainer } from "Themes/StyledComponents";

import { Fonts } from "Themes";
import IconList from "Components/IconList";
import LoadingIcon from "Components/LoadingIcon";
import React from "react";
import styled from "styled-components";

const TextContainer = styled.div`
  width: 50%;
  font-family: ${Fonts.primaryFontFamily};
`;

const LinksList = (props) => {
  const { projectResources, addOnClick, editable, customLinkImage } = props;
  if (!projectResources) return <LoadingIcon />;
  return (
    <>
      {projectResources.map(
        ({ resourceLink, resource: { resourceImage, resourceName } }, key) => {
          return (
            <IconList
              key={key}
              image={
                resourceName === "Website" ? customLinkImage : resourceImage
              }
              onClick={() => (window.location = resourceLink)}
            />
          );
        }
      )}
      {editable && (
        <>
          {projectResources.length === 0 && (
            <TextContainer>
              Click to add some links to your project
            </TextContainer>
          )}

          <AddIconContainer onClick={addOnClick}>
            <AddIcon fontSize={20} />
          </AddIconContainer>
        </>
      )}
    </>
  );
};

export default LinksList;
